export default "__VITE_ASSET__CQ4ZKtNd__"